import { combineReducers } from 'redux'
import salesExpensesStats from './salesExpensesStats'
import topSalesStats from './topSalesStats'
import transactionStats from './transactionStats'

export default combineReducers({
  salesExpensesStats,
  topSalesStats,
  transactionStats,
})
